import { render, staticRenderFns } from "./Peers.vue?vue&type=template&id=a3c8ac3c&scoped=true"
import script from "./Peers.vue?vue&type=script&lang=js"
export * from "./Peers.vue?vue&type=script&lang=js"
import style0 from "./Peers.vue?vue&type=style&index=0&id=a3c8ac3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8ac3c",
  null
  
)

export default component.exports